export default __webpack_public_path__ + "static/media/ARSMaquettePro-Medium.5494805c.ttf";